import Util from "@/components/js/util.js";
import { do_ } from "@/api/index";
import dlgFunc from "../../views/textProofreading/index.js";
import { addTextSelectionColor, confidenceName } from "../../utils/common.js";

export default {
  data() {
    return {
      errorStatistics: {
        list: [],
      },
      loading: false, // 校对中
      percentage: 0, //进度条值
      timeStart: "", //进度条计
      isContinue: true, // 暂停（false）或继续(true)
      currentTime: {
        interval: null,
        second: 0,
        time: "",
      },
      estimated: {
        interval: null,
        time: 0,
      },
      proofreadError: false,
      radio: null,
      proofreading: null,
      errorTypeCoun: 0,
    };
  },
  created() {
    this.$nextTick(() => {
      const isContinue = wps.PluginStorage.getItem("isContinue");
      if (isContinue !== undefined && isContinue !== null && isContinue !== "") {
        this.isContinue = isContinue === true || isContinue === "true";
      }
      this.loading = true;
      this.radio = localStorage.getItem("radio");
      this.proofreading = localStorage.getItem("proofreading");
      this.inspect();
    });
  },
  watch: {
    // 监听loading状态控制进度条显示
    loading(value) {
      const that = this;
      if (value) {
        that.increase();
        that.startTime();
      } else {
        that.increaseend();
        this.stopTiming();
      }
    },
  },
  methods: {
    /**
     * 校对
     * obj 段落或句子对象
     * count 总数
     */
    async getProofreading(obj, count) {
      const { domains, wps } = localStorage;
      const {
        user: { pwd, userid },
      } = JSON.parse(wps);
      const all = dlgFunc.CWps.Application.ActiveDocument.Range();
      // 上次校验被暂停的
      const breakLine = Number(localStorage.getItem("breakLine"));
      const all_end = all.End;

      const { radio, proofreading } = this;

      this.estimated.time = this.estimated.time
        ? this.estimated.time
        : Math.floor(all_end / 200);
      this.startEstimated();

      let paramsArray = [];
      for (let index = breakLine || 0; index < count; index++) {
        const findItem = obj.Item(index + 1);
        const item = setingDefault.splittype == 1 ? findItem.Range : findItem;
        // 空格转换
        const text = item.Text;
        const reg = /^\s+$/g;

        if (!reg.test(text)) {
          let params = {
            method: "correct",
            text: text.replace(/\r|\n/,""),
            domains: domains,
            error_types: "[7001|7002]",
            strict_degree: proofreading == 1 ? "l" : "h",
            ukey: pwd,
            userid: userid,
          };
          // 综合校对
          if (radio === "radio2") {
            params = {
              ...params,
              method: "proofread",
              domains: "ALL",
              strict_degree: proofreading == 1 ? "l" : "h",
            };
          }
          paramsArray.push({ params, item, index });
        }
      }

      const launchNumber = 3; // 每批并发数：降到 3 减轻服务器瞬时压力，避免占满连接池
      const num = Math.ceil(paramsArray.length / launchNumber);

      // JS 层超时兜底：axios 的 timeout 在部分 WPS 引擎下对“挂死”请求不生效，
      // 用 Promise.race + setTimeout 保证请求必定在 deadline 内 settle，避免整轮卡死
      const withTimeout = (promise, ms) => {
        let timer;
        const timeout = new Promise((_, reject) => {
          timer = setTimeout(() => reject(new Error("请求超时(" + ms + "ms)")), ms);
        });
        // 主请求先返回则清理定时器，避免产生未处理的超时 rejection
        promise.then(() => clearTimeout(timer), () => clearTimeout(timer));
        return Promise.race([promise, timeout]);
      };

      // 单个片段请求：超时兜底 + 指数退避重试，吸收瞬时网络抖动
      const requestProofread = async (index, retry = 2) => {
        try {
          return await withTimeout(do_(paramsArray[index].params), 60000);
        } catch (err) {
          if (retry > 0) {
            // 退避间隔：1s、2s
            await new Promise((resolve) => setTimeout(resolve, (3 - retry) * 1000));
            return requestProofread(index, retry - 1);
          }
          throw err;
        }
      };

      let failedCount = 0;
      const failReasons = [];
      for (let i = 0; i < num; i++) {
        // 用户暂停：保存当前位置后退出
        if (!this.isContinue) {
          localStorage.setItem(
            "breakLine",
            paramsArray[i * launchNumber].index
          );
          break;
        }

        // 每批最多 launchNumber 个并发；单个片段失败不连累整批
        const api = [];
        for (let j = 0; j < launchNumber; j++) {
          const idx = i * launchNumber + j;
          if (idx < paramsArray.length) {
            api.push(
              requestProofread(idx).catch((err) => {
                failedCount += 1;
                failReasons.push("片段" + idx + "请求失败: " + (err && err.message ? err.message : err));
                console.error("校对片段请求失败:", err);
                return []; // 空数组，addColor 会跳过该片段
              })
            );
          }
        }

        console.log("[校对] 批次", i + 1, "/", num, "开始，本批", api.length, "个");
        const results = await Promise.all(api);
        console.log("[校对] 批次", i + 1, "请求完成");
        // 标记阶段单独兜底：某个 Range 偏移非法等异常不应让整轮校对静默卡死
        try {
          this.addColor(paramsArray, results, i, launchNumber);
        } catch (err) {
          console.error("[校对] 批次", i + 1, "标记失败:", err);
          failedCount += api.length;
          failReasons.push("批次" + (i + 1) + "标记出错: " + (err && err.message ? err.message : err));
        }
        console.log("[校对] 批次", i + 1, "标记完成，累计错误", this.errorStatistics.list.length);
        // 批间小间隔，给服务器喘息，降低限流/超时概率（最后一批不等）
        if (i < num - 1) {
          await new Promise((resolve) => setTimeout(resolve, 300));
        }
      }

      if (this.isContinue) {
        localStorage.setItem("breakLine", "");
        this._errorClassCount();
        this.stop();
        this._reportFailures(failedCount, paramsArray.length, failReasons);
      }
    },
    addColor(paramsArray, array = [], apiNumber, launchNumber) {
      if (!Array.isArray(array))return false;
      array = array.reduce((prev, curr, index) => {
        if(Array.isArray(curr) && curr.length > 0) {
          curr = curr.map((child) => {
            const obj = paramsArray[apiNumber * launchNumber + index].item;
            const { Start, Text, End } = obj;
            const pageNo = obj.Information(1);
            const rowNumber = obj.Information(10);

            const { offset, error_word } = child;
            const brIdx = Text.search(/\r|\n/);
            const adj = brIdx >= 0 && offset >= brIdx ? 1 : 0;
            const start_ = offset + Start + adj;
            const end_ = start_ + error_word.length;
            const Child_ = {
              ...child,
              originalSentenceStart: Start,
              originalSentenceEnd: End,
              text: Text,
              start: start_,
              errorTypeName: confidenceName(child),
              end: end_,
              pageNo,
              rowNumber,
            };
  
            try { addTextSelectionColor(Child_); } catch (e) { console.error("标记单个错误失败:", e, Child_); }
            return Child_;
          });
          prev.push(curr);
        }
        if(curr.error_word) {
          const obj = paramsArray[apiNumber * launchNumber + index].item;
            const { Start, Text, End } = obj;
            const pageNo = obj.Information(1);
            const rowNumber = obj.Information(10);

            const { offset, error_word } = curr;
            const brIdx = Text.search(/\r|\n/);
            const adj = brIdx >= 0 && offset >= brIdx ? 1 : 0;
            const start_ = offset + Start + adj;
            const end_ = start_ + error_word.length;
            const Child_ = {
              ...curr,
              originalSentenceStart: Start,
              originalSentenceEnd: End,
              text: Text,
              start: start_,
              errorTypeName: confidenceName(curr),
              end: end_,
              pageNo,
              rowNumber,
            };
  
            try { addTextSelectionColor(Child_); } catch (e) { console.error("标记单个错误失败:", e, Child_); }
            prev.push(Child_);
        }
        return prev;
      }, []);

      this.errorStatistics.list = this.errorStatistics.list.concat(...array);
      localStorage.setItem(
        "errorStatistics",
        JSON.stringify(this.errorStatistics)
      );
    },
    // 校对结束后汇总失败片段，给用户明确反馈（不再因单点失败整轮中断）
    _reportFailures(failedCount, total, reasons) {
      if (failedCount <= 0) return;
      const allFailed = failedCount >= total;
      if (reasons && reasons.length) {
        console.warn("[校对] 失败明细:\n" + reasons.join("\n"));
      }
      const head = allFailed
        ? `校对请求全部失败（共 ${total} 个片段），请检查网络后稍后重试。`
        : `本次校对完成，但有 ${failedCount}/${total} 个片段未能处理，建议重新校对以补全。`;
      if (allFailed) {
        this.proofreadError = true;
      }
      // 用户不便开调试控制台：有失败明细时直接弹模态框，把每条失败原因列出来
      if (reasons && reasons.length) {
        const detail = reasons.map((r) => "• " + r).join("<br>");
        const html = head + "<br><br><b>失败原因：</b><br>" + detail;
        if (this.$alert) {
          this.$alert(html, allFailed ? "校对失败" : "部分片段未处理", {
            confirmButtonText: "确定",
            dangerouslyUseHTMLString: true,
          });
        } else {
          alert(head + "\n\n失败原因：\n" + reasons.map((r) => "• " + r).join("\n"));
        }
      } else if (this.$message) {
        this.$message[allFailed ? "error" : "warning"](head);
      } else {
        alert(head);
      }
    },
    showErrata() {
      dlgFunc.CWps.ShowDialog(
        Util.GetUrlPath() + "errata",
        "勘误表",
        300 * window.devicePixelRatio,
        300 * window.devicePixelRatio,
        true
      );
    },
    /**
     * type 值含有“敏感词”3个字的（文章中标记紫色部分内容），为敏感词；
     * confidence 值大于0.85（文章中标记红色部分内容），为错词；
     * confidence值小于等于0.85（文章中标记黄色部分内容），为疑词；
     */
    _errorClassCount() {
      let dataList = this.errorStatistics.list;
      if (!dataList || dataList.length <= 0) {
        return;
      }
      let mgc = 0; //敏感词
      let cc = 0; //错词
      let yc = 0; // 疑词
      for (var i = 0; i < dataList.length; i++) {
        if (String(dataList[i].type || "").indexOf("敏感词") > 0) {
          mgc++;
        }
        if (
          String(dataList[i].type || "").indexOf("敏感词") < 0 &&
          dataList[i].confidence > 0.85
        ) {
          cc++;
        }
        if (dataList[i].confidence <= 0.85) {
          yc++;
        }
      }

      let res = 0;
      if (mgc > 0) {
        res++;
      }
      if (cc > 0) {
        res++;
      }
      if (yc > 0) {
        res++;
      }
      this.errorTypeCount = res;
    },
    startEstimated() {
      this.estimated.interval = setInterval(() => {
        const { time } = this.estimated;
        if (time === 0) {
          clearInterval(this.estimated.interval);
        } else {
          this.estimated.time = time - 1;
        }
      }, 1000);
    },
    startTime() {
      this.currentTime.interval = setInterval(() => {
        const { second } = this.currentTime;
        const num = second + 1;
        var min = Math.floor(num % 3600); //分钟
        const time =
          Math.floor(num / 3600) +
          "时" +
          Math.floor(min / 60) +
          "分" +
          (num % 60) +
          "秒";

        this.currentTime = {
          ...this.currentTime,
          second: num,
          time,
        };
      }, 1000);
    },
    stopTiming() {
      clearInterval(this.currentTime.interval);
      clearInterval(this.estimated.interval);
    },
    increase() {
      const that = this;
      that.timeStart = setInterval(() => {
        if (that.percentage < 95) {
          that.percentage += 2;
        }
        if (that.percentage > 100) {
          that.percentage = 100;
        }
      }, 1000);
    },
    increaseend() {
      this.percentage = 100;
      clearInterval(this.timeStart);
    },
    // 暂停或继续校验
    handlerSuspend() {
      this.isContinue = !this.isContinue;
      wps.PluginStorage.setItem("isContinue", this.isContinue);

      // 是否继续
      if (this.isContinue) {
        this.increase();
        this.startTime();
        this.inspect();
      } else {
        this.stopTiming();
        clearInterval(this.timeStart);
      }
    },
    // 停止校验并显示结果
    hanldeStop() {
      this.loading = false;
      this.isContinue = false;
      wps.PluginStorage.setItem("isContinue", this.isContinue);
    },
    stop() {
      this.stopTiming();
      this.estimated.time = 0;
      wps.PluginStorage.setItem("isContinue", true);
      this.isContinue = true;
      this.percentage = 100;
      this.loading = false;
    },
    close() {
      window.close();
    },
  },
};
